import { useFormContext } from 'react-hook-form'

import { Input } from '~components/Chat/components'
import { getParseBodyParams, getType } from '~components/Chat/helpers'
import { REQUIRED_VALIDATION, RSA_REGEX } from '~config'

type Props = {
  dialog: Stepper
  dialogType: ApiGetStepResponse['data'][0]['type']
  index: number
  setAnswers: (answer: string) => void
  handleAnswer: Function
}

const RSANumber = ({
  dialog,
  dialogType,
  index,
  setAnswers,
  handleAnswer,
}: Props) => {
  const { getValues } = useFormContext()

  const answer = getType(dialog, 'rsa_number')[0]
  const parsedBodyParam = getParseBodyParams(answer)
  const id = Object.keys(parsedBodyParam)[0]

  const handleTextInputValue = (a: Answer, answerId: string) => {
    const value = getValues(answerId)
    setAnswers(value)
    handleAnswer(a.action, { [`${answerId}`]: value })
  }

  return (
    <Input
      key={dialogType + index}
      id={id}
      type="text"
      placeholder={answer.label}
      onSubmit={() => handleTextInputValue(answer, id)}
      validator={{
        ...REQUIRED_VALIDATION,
        pattern: {
          value: RSA_REGEX,
          message: "L'identifiant doit être une suite de 7 chiffres",
        },
      }}
    />
  )
}

export default RSANumber
